<template>
  <!--
    Indicateur de tri double-triangle ▲▼ , pattern Excel / DBeaver .
    Remplace l'icône Buefy unique ( flèche qui pivote ) par deux
    triangles empilés verticalement , avec mise en évidence du sens
    actif ( triangle correspondant en noir et légèrement agrandi ) .

    <p><b>Contrat</b> :
    <ul>
      <li><b>SRP</b> : ce composant fait UNIQUEMENT le rendu visuel .
          La résolution de la direction ( asc / desc / none ) reste à
          la charge du parent ( typiquement une view de tableau qui
          écoute l'event {@code @sort} d'un {@code b-table} ) ;</li>
      <li><b>OCP</b> : ajouter un nouvel état ( ex "mixed" en
          multi-tri ) = ajouter une valeur d'union dans
          {@link SortDirection} + une branche CSS , sans toucher au
          template ;</li>
      <li><b>Zero side-effect</b> : tout le CSS est {@code scoped} ,
          aucun sélecteur global . Le composant peut être placé dans
          n'importe quel slot {@code #header} d'un b-table sans
          risque de pollution du layout environnant ;</li>
      <li><b>Footprint visuel</b> stable : inline-block , taille fixe
          ( ~10px × 14px ) , équivalente à une b-icon {@code is-small} -
          remplace donc une b-icon sans changer la largeur de colonne .</li>
    </ul>
  -->
  <span
    class="sort-tri"
    :class="`sort-tri--${direction}`"
    :aria-label="ariaLabel"
    role="img"
  >
    <span class="sort-tri__up" />
    <span class="sort-tri__down" />
  </span>
</template>

<script lang="ts">
export type SortDirection = "asc" | "desc" | "none";

export default {
  name: "SortDoubleTriangle",
  props: {
    /** Direction de tri courante sur la colonne associée . */
    direction: {
      type: String as () => SortDirection,
      required: false,
      default: "none",
      validator: (v: string) => ["asc", "desc", "none"].includes(v),
    },
  },
  computed: {
    ariaLabel(): string {
      if (this.direction === "asc") return "Trié par ordre croissant";
      if (this.direction === "desc") return "Trié par ordre décroissant";
      return "Cliquer pour trier";
    },
  },
};
</script>

<style lang="scss" scoped>
.sort-tri {
  display: inline-block;
  position: relative;
  width: 13px;
  height: 17px;
  vertical-align: middle;
  line-height: 1;
  user-select: none;
}

.sort-tri__up,
.sort-tri__down {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  opacity: 0.3;
  pointer-events: none;
  transition: opacity 0.15s ease, border-color 0.15s ease;
}
.sort-tri__up {
  top: 0;
  border-bottom: 6px solid currentColor;
}
.sort-tri__down {
  bottom: 0;
  border-top: 6px solid currentColor;
}

/* ASC actif : triangle haut noir agrandi , bas atténué */
.sort-tri--asc .sort-tri__up {
  opacity: 1;
  border-left-width: 6px;
  border-right-width: 6px;
  border-bottom: 8px solid #000;
  top: -1px;
}
.sort-tri--asc .sort-tri__down {
  opacity: 0.2;
}

/* DESC actif : triangle bas noir agrandi , haut atténué */
.sort-tri--desc .sort-tri__up {
  opacity: 0.2;
}
.sort-tri--desc .sort-tri__down {
  opacity: 1;
  border-left-width: 6px;
  border-right-width: 6px;
  border-top: 8px solid #000;
  bottom: -1px;
}
</style>
